import React from 'react';
import { ChevronDown } from 'lucide-react';

const ClassDetailsStep = ({ formData, updateField, boards, grades, classModes }) => (
    <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-300">
        <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">Education Board</label>
            <div className="grid grid-cols-3 gap-2">
                {boards.map(b => (
                    <button
                        key={b.value}
                        onClick={() => updateField('board', b.value)}
                        className={`py-3 px-4 rounded-xl border-2 text-sm font-medium transition-all ${formData.board === b.value
                            ? 'border-[#041f96] bg-[#041f96] text-white shadow-md shadow-blue-100'
                            : 'border-gray-200 text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        {b.label}
                    </button>
                ))}
            </div>
        </div>

        <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">Class / Grade</label>
            <div className="relative">
                <select
                    value={formData.grade}
                    onChange={(e) => updateField('grade', e.target.value)}
                    className={`w-full px-4 py-3 pr-10 border-2 rounded-xl text-sm font-medium appearance-none cursor-pointer transition-all focus:outline-none ${formData.grade
                        ? 'border-[#041f96] bg-[#041f96]/5 text-gray-900'
                        : 'border-gray-200 text-gray-500'
                        }`}
                >
                    <option value="">Select class or grade...</option>
                    {grades.map(g => (
                        <option key={g.value} value={g.value}>{g.label}</option>
                    ))}
                </select>
                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
            </div>
        </div>

        <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">Preferred Class Mode</label>
            <div className="grid grid-cols-2 gap-3">
                {classModes.map(m => (
                    <button
                        key={m.value}
                        onClick={() => updateField('class_mode', m.value)}
                        className={`p-4 rounded-2xl border-2 text-left transition-all ${formData.class_mode === m.value
                            ? 'border-[#041f96] bg-[#041f96]/5 shadow-md shadow-blue-100'
                            : 'border-gray-200 hover:border-gray-300'
                            }`}
                    >
                        {React.createElement(m.icon, { className: "h-5 w-5 text-[#041f96]" })}
                        <p className="font-semibold text-sm text-gray-900 mt-1">{m.label}</p>
                        <p className="text-xs text-gray-500">{m.desc}</p>
                    </button>
                ))}
            </div>
        </div>

        <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">Budget</label>
            <div className="flex items-center gap-3">
                <div className="flex border-2 border-gray-200 rounded-xl overflow-hidden">
                    {['monthly', 'hourly'].map(type => (
                        <button
                            key={type}
                            onClick={() => updateField('budget_type', type)}
                            className={`px-4 py-2.5 text-sm font-medium transition-colors ${formData.budget_type === type
                                ? 'bg-[#041f96] text-white'
                                : 'text-gray-600 hover:bg-gray-50'
                                }`}
                        >
                            {type === 'monthly' ? 'Monthly' : 'Hourly'}
                        </button>
                    ))}
                </div>
                <div className="relative flex-1">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-medium">₹</span>
                    <input
                        type="number"
                        value={formData.budget_amount}
                        onChange={(e) => updateField('budget_amount', parseInt(e.target.value) || 0)}
                        className="w-full pl-8 pr-4 py-2.5 border-2 border-gray-200 rounded-xl text-sm focus:border-[#041f96] focus:outline-none"
                        placeholder="5000"
                    />
                </div>
            </div>
        </div>
    </div>
);

export default ClassDetailsStep;
